import http from './http'
import { getToken } from './auth'

const base = 'airlineCrews'

export async function create(payload) {

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': getToken()
        }
    }
    return await http.post(`${base}`, payload, config)
}

export async function get() {
    return await http.get(`${base}`, {
        headers: {
            'x-auth-token': getToken()
        }
    })
}

export async function getById(id) {
    return await http.get(`${base}/by-id/${id}`, {
        headers: {
            'x-auth-token': getToken()
        }
    })
}


export async function update(id, payload) {

    return await http.patch(`${base}/${id}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': getToken()
        }
    })
}

export async function deleteAirlineCrew(id) {
    const config = {
        headers: {
            'x-auth-token': getToken()
        }
    }
    return await http.delete(`${base}/${id}`, config)
}

export async function verifyPublicKey(key) {
    return await http.post(`${base}/verify-qrcode-key?key=${key}`, {
        headers: {}
    })
}